// @generated by protoc-gen-es v2.0.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/studio/v2/types.proto (package creativefabrica.studio.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/studio/v2/types.proto.
 */
export const file_creativefabrica_studio_v2_types: GenFile = /*@__PURE__*/
  fileDesc("CiVjcmVhdGl2ZWZhYnJpY2Evc3R1ZGlvL3YyL3R5cGVzLnByb3RvEhljcmVhdGl2ZWZhYnJpY2Euc3R1ZGlvLnYyIoMBCgtWZWN0b3JDbG9jaxJECgdlbnRyaWVzGAEgAygLMjMuY3JlYXRpdmVmYWJyaWNhLnN0dWRpby52Mi5WZWN0b3JDbG9jay5FbnRyaWVzRW50cnkaLgoMRW50cmllc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoBToCOAEi2wEKB1Byb2plY3QSCgoCaWQYASABKAkSDwoHdXNlcl9pZBgCIAEoCRIMCgRuYW1lGAMgASgJEi8KC2NyZWF0ZV90aW1lGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgt1cGRhdGVfdGltZRgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASQwoPYWN0aXZlX3JldmlzaW9uGAYgASgLMiouY3JlYXRpdmVmYWJyaWNhLnN0dWRpby52Mi5Qcm9qZWN0UmV2aXNpb24i0QEKD1Byb2plY3RSZXZpc2lvbhIKCgJpZBgBIAEoCRISCgpwcm9qZWN0X2lkGAIgASgJEg8KB3VzZXJfaWQYAyABKAkSPAoMdmVjdG9yX2Nsb2NrGAQgASgLMiYuY3JlYXRpdmVmYWJyaWNhLnN0dWRpby52Mi5WZWN0b3JDbG9jaxIvCgtjcmVhdGVfdGltZRgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEAoIZmlsZV91cmwYBiABKAkSDAoEYm9keRgHIAEoCSpHCgxUZW1wbGF0ZVR5cGUSHQoZVEVNUExBVEVfVFlQRV9VTlNQRUNJRklFRBAAEhgKFFRFTVBMQVRFX1RZUEVfR0xPQkFMEAEqjQEKDVVzZXJCYW5TdGF0dXMSHwobVVNFUl9CQU5fU1RBVFVTX1VOU1BFQ0lGSUVEEAASGAoUVVNFUl9CQU5fU1RBVFVTX05PTkUQARIdChlVU0VSX0JBTl9TVEFUVVNfU0hBRE9XQkFOEAISIgoeVVNFUl9CQU5fU1RBVFVTX0RFU0lHTkVSX0JMT0NLEANCT1pNZ2l0aHViLmNvbS9jcmVhdGl2ZWZhYnJpY2Evc2NoZW1hcy9wa2cvZ2VuL2NyZWF0aXZlZmFicmljYS9zdHVkaW8vdjI7c3R1ZGlvdjJiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * @generated from message creativefabrica.studio.v2.VectorClock
 */
export type VectorClock = Message<"creativefabrica.studio.v2.VectorClock"> & {
  /**
   * @generated from field: map<string, int32> entries = 1;
   */
  entries: { [key: string]: number };
};

/**
 * JSON type for the message creativefabrica.studio.v2.VectorClock.
 */
export type VectorClockJson = {
  /**
   * @generated from field: map<string, int32> entries = 1;
   */
  entries?: { [key: string]: number };
};

/**
 * Describes the message creativefabrica.studio.v2.VectorClock.
 * Use `create(VectorClockSchema)` to create a new message.
 */
export const VectorClockSchema: GenMessage<VectorClock, VectorClockJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_types, 0);

/**
 * @generated from message creativefabrica.studio.v2.Project
 */
export type Project = Message<"creativefabrica.studio.v2.Project"> & {
  /**
   * project id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * the user that owns the project
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * name of the project.
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 5;
   */
  updateTime?: Timestamp;

  /**
   * the active revision of the project
   *
   * @generated from field: creativefabrica.studio.v2.ProjectRevision active_revision = 6;
   */
  activeRevision?: ProjectRevision;
};

/**
 * JSON type for the message creativefabrica.studio.v2.Project.
 */
export type ProjectJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string name = 3;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 4;
   */
  createTime?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp update_time = 5;
   */
  updateTime?: TimestampJson;

  /**
   * @generated from field: creativefabrica.studio.v2.ProjectRevision active_revision = 6;
   */
  activeRevision?: ProjectRevisionJson;
};

/**
 * Describes the message creativefabrica.studio.v2.Project.
 * Use `create(ProjectSchema)` to create a new message.
 */
export const ProjectSchema: GenMessage<Project, ProjectJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_types, 1);

/**
 * @generated from message creativefabrica.studio.v2.ProjectRevision
 */
export type ProjectRevision = Message<"creativefabrica.studio.v2.ProjectRevision"> & {
  /**
   * revision id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock vector_clock = 4;
   */
  vectorClock?: VectorClock;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: Timestamp;

  /**
   * @generated from field: string file_url = 6;
   */
  fileUrl: string;

  /**
   * the body of the project at this revision.
   *
   * @generated from field: string body = 7;
   */
  body: string;
};

/**
 * JSON type for the message creativefabrica.studio.v2.ProjectRevision.
 */
export type ProjectRevisionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId?: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId?: string;

  /**
   * @generated from field: creativefabrica.studio.v2.VectorClock vector_clock = 4;
   */
  vectorClock?: VectorClockJson;

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: TimestampJson;

  /**
   * @generated from field: string file_url = 6;
   */
  fileUrl?: string;

  /**
   * @generated from field: string body = 7;
   */
  body?: string;
};

/**
 * Describes the message creativefabrica.studio.v2.ProjectRevision.
 * Use `create(ProjectRevisionSchema)` to create a new message.
 */
export const ProjectRevisionSchema: GenMessage<ProjectRevision, ProjectRevisionJson> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studio_v2_types, 2);

/**
 * @generated from enum creativefabrica.studio.v2.TemplateType
 */
export enum TemplateType {
  /**
   * @generated from enum value: TEMPLATE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEMPLATE_TYPE_GLOBAL = 1;
   */
  GLOBAL = 1,
}

/**
 * JSON type for the enum creativefabrica.studio.v2.TemplateType.
 */
export type TemplateTypeJson = "TEMPLATE_TYPE_UNSPECIFIED" | "TEMPLATE_TYPE_GLOBAL";

/**
 * Describes the enum creativefabrica.studio.v2.TemplateType.
 */
export const TemplateTypeSchema: GenEnum<TemplateType, TemplateTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studio_v2_types, 0);

/**
 * @generated from enum creativefabrica.studio.v2.UserBanStatus
 */
export enum UserBanStatus {
  /**
   * @generated from enum value: USER_BAN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USER_BAN_STATUS_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: USER_BAN_STATUS_SHADOWBAN = 2;
   */
  SHADOWBAN = 2,

  /**
   * @generated from enum value: USER_BAN_STATUS_DESIGNER_BLOCK = 3;
   */
  DESIGNER_BLOCK = 3,
}

/**
 * JSON type for the enum creativefabrica.studio.v2.UserBanStatus.
 */
export type UserBanStatusJson = "USER_BAN_STATUS_UNSPECIFIED" | "USER_BAN_STATUS_NONE" | "USER_BAN_STATUS_SHADOWBAN" | "USER_BAN_STATUS_DESIGNER_BLOCK";

/**
 * Describes the enum creativefabrica.studio.v2.UserBanStatus.
 */
export const UserBanStatusSchema: GenEnum<UserBanStatus, UserBanStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studio_v2_types, 1);

